









































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import _ from "lodash";
import TabBar from "@/components/TabBar.vue";
import { API_BASE_URL, COLOUR_OPTIONS } from "@/shared/global-values";
import { groupExpensesByDate } from "@/shared/utils";
import IExpense from "@/types/expense";

export default Vue.extend({
  components: {
    TabBar,
  },
  data() {
    return {
      expenses: [] as IExpense[],
      debouncedSearchFn: _.debounce(async function(query: string): Promise<void> {
        const params: URLSearchParams = new URLSearchParams();
        params.set("q", query);

        const token: string = await firebase.auth().currentUser!.getIdToken();
        const response: AxiosResponse = await axios.get(`${API_BASE_URL}/search/expenses`, { params, withCredentials: true, headers: { Authorization: `Bearer ${token}` } });

        // @ts-ignore
        this.expenses = response.data.expenses.reduce((expenses: IExpense[], expense: IExpense) => {
          const colourOption = COLOUR_OPTIONS.find((option) => option.colour === expense.colour);
          expense.colourHex = colourOption!.hex;

          return [...expenses, expense];
        }, []);
      }, 1000),
    };
  },
  computed: {
    expensesGroupedByDate(): { [date: string]: IExpense[] } {
      return groupExpensesByDate(this.expenses);
    },
  },
  methods: {
    async search(event: Event): Promise<void> {
      const input: HTMLInputElement = event.currentTarget as HTMLInputElement;

      if (input.value.trim().length >= 3) {
        try {
          await this.debouncedSearchFn(input.value.trim());
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
});
